// extracted by mini-css-extract-plugin
export var dot = "_r8-2";
export var wave = "_r8-0";
export var waveSmall = "_r8-1";